import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	createObject,
	deleteObject,
	editObject,
	editObjectConnection,
	getObjectConnection,
	getObjectsRegister,
	getSearchedData,
	updateDocument,
	uploadDocument,
} from "./objectsRegister.thunks";

interface ObjectsRegisterSlice {
	id: number | null;
	objectsRegisterList: any[];
	objectConnection: any[];
	lastPart: number | null;

	searchValue: string;
	searchedData: any[];
	searchMode: boolean;
	searchPending: boolean;
	lastSearchedPart: number | null;
}

const initialState: ObjectsRegisterSlice = {
	id: null,
	objectsRegisterList: [],
	objectConnection: [],
	lastPart: 0,

	searchValue: "",
	searchedData: [],
	searchMode: false,
	searchPending: false,
	lastSearchedPart: 0,
};

const objectsRegisterSlice = createSlice({
	name: "objectsRegisterSlice",
	initialState,
	reducers: {
		ClearObjectConnection(state, action: PayloadAction) {
			state.objectConnection = [];
		},
		ChangeId(state, action: PayloadAction<number>) {
			state.id = action.payload;
			state.objectsRegisterList = [];
			state.lastPart = 0;
		},
		ChangeStatus(state, action: PayloadAction<number>) {
			const objectIndex = state.objectsRegisterList.findIndex((object) => object.id === action.payload);
			if (state.objectsRegisterList[objectIndex]) {
				state.objectsRegisterList[objectIndex].statusAdditional = true;
			}
		},

		ChangeSearchValue(state, action: PayloadAction<string>) {
			state.searchValue = action.payload;
			state.searchedData = [];
			state.lastSearchedPart = 0;

			if (!state.searchValue) {
				state.searchMode = false;
				state.searchPending = false;

				state.objectsRegisterList = [];
				state.lastPart = 0;
			} else {
				state.searchMode = false;
				state.searchMode = true;
				state.searchPending = true;
			}
		},

		resetStep_2_2: () => initialState,
	},

	extraReducers: (builder) => {
		builder.addCase(
			getObjectsRegister.fulfilled,
			(state, action: PayloadAction<{ response: any[]; quantity: number }>) => {
				state.objectsRegisterList.push(...action.payload.response);
				if (
					action.payload.response.length &&
					state.lastPart !== null &&
					action.payload.response.length === action.payload.quantity
				)
					state.lastPart++;
				else state.lastPart = null;
			},
		);
		builder.addCase(getSearchedData.fulfilled, (state, action) => {
			state.searchedData.push(...action.payload.response);
			state.searchPending = false;
			if (
				action.payload.response.length &&
				state.lastSearchedPart !== null &&
				action.payload.response.length === action.payload.quantity
			)
				state.lastSearchedPart++;
			else state.lastSearchedPart = null;
		});
		builder.addCase(createObject.fulfilled, (state, action: PayloadAction<any>) => {
			if (state.searchMode) {
				state.searchedData.unshift(action.payload);
				if (state.lastSearchedPart !== null) {
					state.searchedData.pop();
				}
			} else {
				state.objectsRegisterList.unshift(action.payload);
				if (state.lastPart !== null) {
					state.objectsRegisterList.pop();
				}
			}
		});
		builder.addCase(editObject.fulfilled, (state, action: PayloadAction<any>) => {
			const objectIndex: number = state.objectsRegisterList.findIndex((object) => object.id === action.payload.id);
			if (objectIndex >= 0) state.objectsRegisterList[objectIndex] = action.payload;

			if (state.searchMode) {
				const objectIndex: number = state.searchedData.findIndex((object) => object.id === action.payload.id);
				state.searchedData[objectIndex] = action.payload;
			}
		});
		builder.addCase(deleteObject.fulfilled, (state, action: PayloadAction<{ deleteId: number; newObject: any }>) => {
			if (state.searchMode) state.searchedData = state.searchedData.filter((obj) => obj.id !== action.payload.deleteId);
			else state.objectsRegisterList = state.objectsRegisterList.filter((obj) => obj.id !== action.payload.deleteId);

			if (action.payload.newObject) {
				if (state.searchMode) state.searchedData.push(action.payload.newObject);
				else state.objectsRegisterList.push(action.payload.newObject);
			}
		});
		builder.addCase(getObjectConnection.fulfilled, (state, action: PayloadAction<any[]>) => {
			state.objectConnection = action.payload;
		});
		builder.addCase(editObjectConnection.fulfilled, (state, action: PayloadAction<any>) => {
			const objectIndex: number = state.objectsRegisterList.findIndex((object) => object.id === action.payload.id);
			state.objectsRegisterList[objectIndex] = action.payload;
		});
		builder.addCase(uploadDocument.fulfilled, (state, action: PayloadAction<any>) => {
			const objectIndex: number = state.objectsRegisterList.findIndex((object) => object.id === action.payload.id);
			state.objectsRegisterList[objectIndex] = action.payload;
		});
		// builder.addCase(deleteDocument.fulfilled, (state, action: PayloadAction<any>) => {
		// 	const objectIndex: number = state.objectsRegisterList.findIndex((object) => object.id === action.payload.id);
		// 	state.objectsRegisterList[objectIndex] = action.payload;
		// });
		builder.addCase(updateDocument.fulfilled, (state, action: PayloadAction<any>) => {
			const objectIndex: number = state.objectsRegisterList.findIndex((object) => object.id === action.payload.id);
			state.objectsRegisterList[objectIndex] = action.payload;
		});
	},
});

export const { ClearObjectConnection, ChangeId, ChangeStatus, ChangeSearchValue, resetStep_2_2 } =
	objectsRegisterSlice.actions;
export default objectsRegisterSlice.reducer;
